export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_02.2f6bad1d.jpg";